import { useCloudfrontLocationQuery } from 'state/hooks/useCloudfrontLocation';
import { useLocale } from 'shared/hooks/useLocale';
import { LocaleEnum } from 'schema/locale';

const US_LOCALES = [LocaleEnum.enUS, LocaleEnum.enQa, LocaleEnum.enDev];

export const IsFromUs = () => {
  const { data: cloudfrontLocation, isPending } = useCloudfrontLocationQuery();
  const locale = useLocale();

  if (!cloudfrontLocation || isPending) return false;

  if (!US_LOCALES.includes(locale)) return false;

  return cloudfrontLocation.country === 'US';
};
